import { cn } from "@/lib/utils";

const NARROW_DESKTOP_ARTIST_COUNT = 3;
const WIDE_DESKTOP_ARTIST_COUNT = 5;

export function artistResultCardClassName(index: number, showAllArtists: boolean): string {
  const hiddenOnNarrowDesktop =
    !showAllArtists && index >= NARROW_DESKTOP_ARTIST_COUNT && index < WIDE_DESKTOP_ARTIST_COUNT;
  const hiddenOnDesktop = !showAllArtists && index >= WIDE_DESKTOP_ARTIST_COUNT;
  return cn(
    "flex flex-col items-center gap-3 group cursor-pointer w-28",
    hiddenOnNarrowDesktop && "lg:hidden xl:flex",
    hiddenOnDesktop && "lg:hidden",
  );
}
